import { PackageService } from './package-service.model';
import { Product } from './product';

export class PackageItem {
    id: number = 0;
    packageService: PackageService = new PackageService();
    product: Product | null = null;
    quantity: number = 0;

    constructor() {}
}
